import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const NavatarLoader = ({ theme }) => {
    const isDark = theme === "dark";
    return (_jsxs("span", { className: `inline-block w-5 h-5 p-0.5 align-top leading-none animate-spinner-rotator ${isDark ? " text-colorBaseGray850" : " text-white"}`, children: [_jsx("span", { className: "inline-block h-full w-1/2 overflow-hidden relative loader-circle-left" }), _jsx("span", { className: "inline-block h-full w-1/2 overflow-hidden relative loader-circle-right" })] }));
};
export default NavatarLoader;
//# sourceMappingURL=NavatarLoader.js.map